import { render, staticRenderFns } from "./UsersManager.vue?vue&type=template&id=321dd04e&scoped=true"
import script from "./UsersManager.vue?vue&type=script&lang=ts"
export * from "./UsersManager.vue?vue&type=script&lang=ts"
import style0 from "./UsersManager.vue?vue&type=style&index=0&id=321dd04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321dd04e",
  null
  
)

export default component.exports